module.exports = __webpack_public_path__ + "img/review_stay.f22317be.png";